import { render, staticRenderFns } from "./FirmDocumentUpload.vue?vue&type=template&id=5c5fd0c8"
import script from "./FirmDocumentUpload.vue?vue&type=script&lang=js"
export * from "./FirmDocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports